<template>
  <VCard class="int-wrap int-item" elevation="0">
    <VCardTitle class="int-title pa-0">
      <div class="int-logo">
        <img :src="logoPath" :alt="integration.name || ''">
      </div>
      <span v-if="integration.integrationEmail" class="ml-3 int-email">
        {{ integration.integrationEmail }}
      </span>
    </VCardTitle>
    <div class="int-btn-wrap">
      <div class="int-btn-row">
        <template v-if="isConnected">
          <template v-if="isHHIntegration">
            <VBtn
              @click="disable"
              color="error"
              class="int-btn"
              :loading="isHHLoading"
            >
              {{ $t('disable') }}
            </VBtn>
            <!-- TODO: Удалить когда будет релиз интеграции HH -->
            <VBtn
              @click="goToHHImportPage"
              color="primary"
              class="int-btn hh-import-btn"
            >
              <span class="hh-import-btn-text-full">{{ $t('importVacanciesFromHH') }}</span>
              <span class="hh-import-btn-text-short">{{ $t('importVacanciesFromHHShort') }}</span>
              <img :src="require('@/assets/img/hh-logo.svg')" class="ml-2" />
            </VBtn>
          </template>
          <template v-else>
            <IntegrationsListItemDisable :integration="integration" />
          </template>
        </template>
        <VBtn
          v-else
          @click="enable"
          color="success"
          class="int-btn"
        >
          {{ $t('enable') }}
        </VBtn>
      </div>
      <IntegrationsVacancyImportDialog>
        <template v-slot:default="{on,attrs}">
          <a v-bind="attrs" v-on="on" class="import-link d-none d-sm-block">
            {{ $t('import') }}
          </a>
        </template>
      </IntegrationsVacancyImportDialog>
    </div>
  </VCard>
</template>

<script>
import ValidationMixin from '@/mixins/ValidationMixin';
import IntegrationsVacancyImportDialog from '@/components/Integrations/IntegrationsVacancyImportDialog';
import IntegrationsListItemDisable from '@/components/Integrations/IntegrationsListItemDisable';
import { getHostUrl } from '@/functions';
import { computed, ref } from '@vue/composition-api';
import useHHIntegration from '@/compositions/useHHIntegration';

export default {
  name: 'IntegrationsListItem',
  components: { IntegrationsVacancyImportDialog, IntegrationsListItemDisable },
  mixins: [ValidationMixin],
  props: {
    integration: {
      type: Object,
      required: true,
    },
  },
  setup(props, { root }) {
    const hhIntegration = useHHIntegration();
    const isDisabling = ref(false);

    async function enable() {
      const code = props.integration.code?.toLowerCase();

      if (code === 'head_hunter' || code === 'head_hunter.ru') {
        await hhIntegration.handleAuthorization(root.$router);
      } else {
        const redirect = `${getHostUrl()}/settings/integrations`;
        document.location.href = `${process.env.VUE_APP_API_URL}/integrations/${props.integration.code}/link?&redirect=${redirect}`;
      }
    }

    async function disable() {
      const code = props.integration.code?.toLowerCase();

      if (code === 'head_hunter' || code === 'head_hunter.ru') {
        isDisabling.value = true;
        try {
          await hhIntegration.removeIntegration();
          await hhIntegration.fetchIntegrationData();
        } finally {
          isDisabling.value = false;
        }
      }
    }

    async function goToHHImportPage() {
      await hhIntegration.goToHHImportPage(root.$router);
    }

    const logoPath = computed(() => {
      if (props.integration.logoUrl) {
        return props.integration.logoUrl;
      }

      const code = props.integration.code?.toLowerCase();
      if (code === 'head_hunter' || code === 'head_hunter.ru') {
        return require('@/assets/img/headhunter-logo2.svg');
      } if (code === 'rabota' || code === 'rabota.ru') {
        return require('@/assets/img/rabota/logo-rabota.svg');
      }

      return require('@/assets/img/rabota/logo-rabota.svg');
    });

    const isConnected = computed(() => {
      const code = props.integration.code?.toLowerCase();

      if (code === 'head_hunter' || code === 'head_hunter.ru') {
        return hhIntegration.isAuthorized.value;
      }

      return props.integration.connected === true;
    });

    const isHHIntegration = computed(() => {
      const code = props.integration.code?.toLowerCase();
      return code === 'head_hunter' || code === 'head_hunter.ru';
    });

    const isHHLoading = computed(() => {
      const code = props.integration.code?.toLowerCase();
      if (code === 'head_hunter' || code === 'head_hunter.ru') {
        return isDisabling.value;
      }
      return false;
    });

    return {
      enable,
      disable,
      goToHHImportPage,
      logoPath,
      isConnected,
      isHHIntegration,
      isHHLoading,
      hhIntegration,
    };
  },
};
</script>

<style lang="scss" scoped>

.int-item {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.int-email {
  font-size: 1rem;
}

.int-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.int-logo {
  width: 7.5rem;
  height: 3.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: .5rem 0.9375rem;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0.25rem;
  margin-right: 1.25rem;
  img {
    max-width: 100%;
  }
}
.int-btn-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
}
.int-btn-row {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}
.int-btn {
  width: 120px;
}
.hh-import-btn {
  width: auto;
  min-width: 120px;
  .hh-import-btn-text-short {
    display: none;
  }

  @media screen and (max-width: 350px) {
    .hh-import-btn-text-full {
      display: none;
    }

    .hh-import-btn-text-short {
      display: inline;
    }
  }
}
.import-link {
  display: inline-block;
  font-size: 0.875rem;
  padding-top: 1.25rem;
}

</style>

<i18n lang="yml" locale="en">
enable: Enable
disable: Disable
connected: Connected
importVacanciesFromHH: Import vacancies from HeadHunter
importVacanciesFromHHShort: Import vacancies from HH
</i18n>
<i18n lang="yml" locale="ru">
enable: Подключить
disable: Отключить
connected: Подключено
import: Импортировать вакансии
importVacanciesFromHH: Импортировать вакансии из HeadHunter
importVacanciesFromHHShort: Импортировать вакансии из HH
</i18n>
